import { useEffect, useState, forwardRef, useImperativeHandle, useRef } from 'react';
import * as S from './WaitingTime.styles';
import { useTranslation } from 'react-i18next';

interface WaitingTimeProps {
  onStart: () => void;
  waitingTime: number;
}

export const WaitingTime = forwardRef(({ onStart, waitingTime }: WaitingTimeProps, ref) => {
  const { t } = useTranslation();
  const [seconds, setSeconds] = useState(waitingTime);
  const hasStartedRef = useRef(false);

  useEffect(() => {
    if (seconds > 0) {
      const interval = setInterval(() => {
        setSeconds((prevSeconds) => prevSeconds - 1);
      }, 1000);

      return () => clearInterval(interval);
    } else if (!hasStartedRef.current) {
      hasStartedRef.current = true;
      onStart();
    }
  }, [seconds, onStart]);

  useImperativeHandle(ref, () => ({
    finishImmediately: () => {
      setSeconds(0);
      hasStartedRef.current = true;
    },
  }));

  return (
    <S.Box>
      <p className="font-bold mb-2">{t('page.mockTest.audioRecorder')}</p>
      <S.TextRed>
        {seconds > 0 ? `${t('page.mockTest.recordingIn')} ${seconds}` : t('page.mockTest.button.recording')}
      </S.TextRed>
    </S.Box>
  );
});
